<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(registerInstructor)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>
                        <b-col lg="6" sm="6">
                            <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="fiscal_year_id"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                    </template>
                                   <b-form-select
                                    plain
                                    v-model="trainerProfile.fiscal_year_id"
                                    :options="fiscalYearList"
                                    id="fiscal_year_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                   <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="organiation_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.org_id"
                                    :options="orgList"
                                    id="organiation_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="office_type_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.office_type_id"
                                    :options="officeTypeList"
                                    id="office_type_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="office_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.office_id"
                                    :options="officeList"
                                    id="office_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Manpower Type" vid="manpower_type" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="manpower_type"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('educational_management.manpower_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.manpower_type"
                                    :options="getManpowerTypeList"
                                    id="manpower_type"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template>
                        <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white">
                                {{ $t('educational_management.instructor_identity') }}
                            </h5>
                        </div>
                    </template>
                    <b-row class="mt-2">
                        <b-col>
                            <ValidationProvider name="Name (En)" vid="name" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="name"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.trainer_name_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                    id="name"
                                    v-model="trainerProfile.name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Name (Bn)" vid="name_bn" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="name_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.trainer_name_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                    id="name_bn"
                                    v-model="trainerProfile.name_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Gender" vid="gender">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="gender"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.gender')}}
                                    </template>
                                   <b-form-select
                                    plain
                                    v-model="trainerProfile.gender"
                                    :options="genderList"
                                    id="org_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="NID" vid="nid">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="nid"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.nid')}}
                                    </template>
                                    <b-form-input
                                    type="number"
                                    id="nid"
                                    v-model="trainerProfile.nid"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Father Name (En)" vid="father_name">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="father_name"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.father_name_en')}}
                                    </template>
                                    <b-form-input
                                    id="father_name"
                                    v-model="trainerProfile.father_name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                         <b-col lg="6"  sm="12">
                            <ValidationProvider name="Father Name (Bn)" vid="father_name_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="father_name_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.father_name_bn')}}
                                    </template>
                                    <b-form-input
                                    id="father_name_bn"
                                    v-model="trainerProfile.father_name_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Mother Name (En)" vid="mother_name">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="mother_name"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.mother_name_en')}}
                                </template>
                                    <b-form-input
                                    id="mother_name"
                                    v-model="trainerProfile.mother_name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Mother Name (Bn)" vid="mother_name_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="mother_name_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.mother_name_bn')}}
                                    </template>
                                    <b-form-input
                                    id="mother_name_bn"
                                    v-model="trainerProfile.mother_name_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Blood Group" vid="blood_group_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="blood_group_id"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.blood_group')}}
                                </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.blood_group_id"
                                    :options="bloodGroupList"
                                    id="blood_group_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Religion" vid="religion">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="religion"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.religion')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.religion_id"
                                    :options="religionList"
                                    id="religion_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                     <b-row>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Photo" vid="photo">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="photo"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.photo')}}
                                </template>
                                    <b-form-file
                                      placeholder="Choose a file"
                                      id="customFile"
                                      v-on:change="onImageChange"
                                      accept="image/*"
                                      v-model="trainerProfile.photo"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-file>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template>
                        <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white"> {{ $t('educational_management.profession_info') }}
                            </h5>
                        </div>
                    </template>
                    <b-row class="mt-2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Organization (En)" vid="org_name" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="org_name"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{$t('educational_management.organization_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                    id="org_name"
                                    v-model="trainerProfile.org_name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Organization (Bn)" vid="org_name_bn" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="org_name_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.organization_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                    id="org_name_bn"
                                    v-model="trainerProfile.org_name_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6"  sm="12">
                           <ValidationProvider name="Designation" vid="designation">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="designation"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.designation_en')}}
                                    </template>
                                    <b-form-input
                                    type="text"
                                    id="pay_grade"
                                    v-model="trainerProfile.designation"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Designation" vid="designation_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="designation_bn"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.designation_bn')}}
                                    </template>
                                    <b-form-input
                                    type="text"
                                    id="pay_grade"
                                    v-model="trainerProfile.designation_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="6"  sm="12">
                        <ValidationProvider name="Service Id" vid="service_id">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="service_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.service_id')}}
                                </template>
                                <b-form-input
                                type="text"
                                id="service_id"
                                v-model="trainerProfile.service_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6"  sm="12">
                        <ValidationProvider name="Pay Grade" vid="pay_grade">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="name"
                                slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                                {{$t('educational_management.pay_grade_en')}}
                                </template>
                                <b-form-input
                                type="text"
                                id="pay_grade"
                                v-model="trainerProfile.pay_grade"
                                :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Pay Grade" vid="pay_grade_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="pay_grade_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.pay_grade_bn')}}
                                    </template>
                                    <b-form-input
                                    type="text"
                                    id="pay_grade"
                                    v-model="trainerProfile.pay_grade_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Email" vid="email" rules="required|email">
                                <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="email"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.email')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-input class="form-control"
                                    v-model="trainerProfile.email"
                                    placeholder="Email"
                                    id="email"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                      <b-row>
                        <b-col  lg="6"  sm="12">
                            <ValidationProvider name="Mobile Number" vid="mobile_no"  rules="required|numeric|min:11|max:11">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="mobile_no"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.mobile_no')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                    id="mobile_no"
                                    v-model="trainerProfile.mobile_no"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template>
                        <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white"> {{ $t('educational_management.academic_inf') }}
                            </h5>
                        </div>
                    </template>
                    <b-row class="mt-2">
                        <b-col>
                            <ValidationProvider name="Highest Degree" vid="highest_degree_en">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="highest_degree_en"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.highest_degree_en')}}
                                    </template>
                                    <b-form-input
                                    id="highest_degree_en"
                                    v-model="trainerProfile.highest_degree_en"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Highest Degree" vid="highest_degree_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="highest_degree_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.highest_degree_bn')}}
                                    </template>
                                    <b-form-input
                                    id="name"
                                    v-model="trainerProfile.highest_degree_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <ValidationProvider name="Board University" vid="board_university_en">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="board_university_en"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.board_university_en')}}
                                    </template>
                                    <b-form-input
                                    id="board_university_en"
                                    v-model="trainerProfile.board_university_en"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Board University" vid="board_university_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="board_university_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('educational_management.board_university_bn')}}
                                    </template>
                                    <b-form-input
                                    id="board_university_bn"
                                    v-model="trainerProfile.board_university_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template>
                        <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white">
                                {{ $t('educational_management.present_business_address') }}
                            </h5>
                        </div>
                    </template>
                    <b-row class="mt-2">
                        <b-col lg="12"  sm="12">
                            <ValidationProvider name="Area Type" vid="pre_area_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="2"
                                    label-for="pre_area_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.area_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_area_id"
                                    :options="areaTypeList"
                                    id="pre_area_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="showData === 1">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Division" vid="pre_division_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_division_id"
                                    :options="divisionPreList"
                                    id="pre_division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="District" vid="pre_district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_district_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_district_id"
                                    :options="districtList"
                                    id="pre_district_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                         </b-col>
                    </b-row>
                    <b-row v-if="showData === 1">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Upazilla" vid="pre_upazila_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_upazila_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.city_corporation')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_city_corporation_id"
                                    :options="cityCorporationList"
                                    id="pre_upazila_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="pre_union_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_union_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.ward')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_ward_id"
                                    :options="wardList"
                                    id="pre_union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 1">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(En)">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_en')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address"
                                    v-model="trainerProfile.pre_address"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                             </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(Bn)" vid="pre_address_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_bn')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address_bn"
                                    v-model="trainerProfile.pre_address_bn"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 1">
                        <b-col lg="6"  sm="12">
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="showData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Division" vid="pre_division_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_division_id"
                                    :options="divisionPreList"
                                    id="pre_division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="District" vid="pre_district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_district_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_district_id"
                                    :options="districtList"
                                    id="pre_district_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                         </b-col>
                    </b-row>
                    <b-row v-if="showData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Upazilla" vid="pre_upazila_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_upazila_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_upazilla')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_upazila_id"
                                    :options="upazilaList"
                                    id="pre_upazila_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="pre_union_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_union_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.pourosoba')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_paurasabha_id"
                                    :options="pauroshobaList"
                                    id="pre_union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="pre_union_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_union_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.ward')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_union_id"
                                    :options="wardList"
                                    id="pre_union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(En)" vid="pre_address">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_en')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address"
                                    v-model="trainerProfile.pre_address"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                             </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(Bn)" vid="pre_address_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_bn')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address_bn"
                                    v-model="trainerProfile.pre_address_bn"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="showData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Division" vid="pre_division_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_division_id"
                                    :options="divisionPreList"
                                    id="pre_division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="District" vid="pre_district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_district_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_district_id"
                                    :options="districtList"
                                    id="pre_district_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Upazilla" vid="pre_upazila_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_upazila_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_upazilla')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_upazila_id"
                                    :options="upazilaList"
                                    id="pre_upazila_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="pre_union_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_union_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_union')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_union_id"
                                    :options="unionList"
                                    id="pre_union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="pre_union_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_union_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.ward')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.pre_ward_id"
                                    :options="wardList"
                                    id="pre_union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(En)" vid="pre_address">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_en')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address"
                                    v-model="trainerProfile.pre_address"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                             </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(Bn)" vid="pre_address_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_bn')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address_bn"
                                    v-model="trainerProfile.pre_address_bn"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                        </b-col>
                    </b-row>
                      <template>
                                <b-row>
                                    <b-col lg="6" sm="12">
                                        <ValidationProvider name="Address Status" vid="is_same">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="is_same"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                <div style="border-bottom: 1px solid #ddd; font-size: 15px; font-weight: bold">
                                                    {{$t('educational_management.permanent_address') + ' :'}}
                                                </div>
                                            </template>
                                            <b-form-checkbox
                                                class="mt-2"
                                                id="is_same"
                                                v-model="trainerProfile.is_same"
                                                name="checkbox-1"
                                                @change="isSameAsPresent($event)"
                                                value="1"
                                                unchecked-value="0"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                                <span class="text-black">{{$t('child_admission_management.same')}}</span>
                                            </b-form-checkbox>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                      </template>
                    <template>
                        <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white"> {{ $t('educational_management.permanent_address') }}</h5>
                        </div>
                    </template>
                    <b-row class="mt-2">
                        <b-col lg="12"  sm="12">
                            <ValidationProvider name="Area Type" vid="per_area_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="2"
                                    label-for="per_area_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.area_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_area_id"
                                    :options="areaTypeList"
                                     :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                     <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="perShowData === 1">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Division" vid="per_division_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_division_id"
                                    :options="divisionPerList"
                                    id="pre_division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="District" vid="per_district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_district_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_district_id"
                                    :options="districtPerList"
                                    id="pre_district_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 1">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="City Corporation" vid="per_city_corporation_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_city_corporation_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.city_corporation')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_city_corporation_id"
                                    :options="cityCorporationList"
                                    id="per_city_corporation_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Ward" vid="per_ward_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_ward_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.ward')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_ward_id"
                                    :options="wardList"
                                    id="per_ward_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 1">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(En)" vid="per_address">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_address"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_en')}}
                                </template>
                                    <b-form-textarea
                                    id="per_address"
                                    v-model="trainerProfile.per_address"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                             </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(Bn)" vid="per_address_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_address_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_bn')}}
                                </template>
                                    <b-form-textarea
                                    id="per_address_bn"
                                    v-model="trainerProfile.per_address_bn"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 1">
                        <b-col lg="6"  sm="12">
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="perShowData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Division" vid="per_division_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_division_id"
                                    :options="divisionPreList"
                                    id="per_division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="District" vid="per_district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_district_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_district_id"
                                    :options="districtPerList"
                                    id="per_district_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Upazilla" vid="per_upazila_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_upazila_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_upazilla')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_upazila_id"
                                    :options="upazilaPerList"
                                    id="per_upazila_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="PouroSoba" vid="per_paurasabha_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_paurasabha_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.pourosoba')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_paurasabha_id"
                                    :options="pauroshobaList"
                                    id="per_paurasabha_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="per_ward_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_ward_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.ward')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_ward_id"
                                    :options="wardList"
                                    id="per_ward_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 2">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(En)" vid="per_address">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_address"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_en')}}
                                </template>
                                    <b-form-textarea
                                    id="per_address"
                                    v-model="trainerProfile.per_address"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                             </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(Bn)" vid="per_address_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_address_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_bn')}}
                                </template>
                                    <b-form-textarea
                                    id="per_address_bn"
                                    v-model="trainerProfile.per_address_bn"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                        </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="perShowData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Division" vid="per_division_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_division_id"
                                    :options="divisionPreList"
                                    id="per_division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="District" vid="per_district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_district_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_district_id"
                                    :options="districtPerList"
                                    id="per_district_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Upazilla" vid="per_upazila_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_upazila_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_upazilla')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_upazila_id"
                                    :options="upazilaPerList"
                                    id="per_upazila_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Union" vid="per_union_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_union_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.name_of_union')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_union_id"
                                    :options="unionPerList"
                                    id="per_union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 3">
                         <b-col lg="6"  sm="12">
                            <ValidationProvider name="Ward" vid="per_ward_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="per_ward_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('educational_management.ward')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="trainerProfile.per_ward_id"
                                    :options="wardList"
                                    id="per_ward_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-row v-if="perShowData === 3">
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(En)" vid="pre_address">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_en')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address"
                                    v-model="trainerProfile.per_address"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                             </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                            <ValidationProvider name="Present/Business Address(Bn)" vid="pre_address_bn">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pre_address_bn"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('educational_management.address_details_bn')}}
                                </template>
                                    <b-form-textarea
                                    id="pre_address_bn"
                                    v-model="trainerProfile.per_address_bn"
                                    rows="1"
                                    max-rows="2"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6"  sm="12">
                        </b-col>
                    </b-row>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                        &nbsp;
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                      </div>
                    </div>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { trainerProfileStoreApi, trainerProfileUpdateApi } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.id) {
      const tmp = this.gettrainerProfileData()
      this.trainerProfile = tmp
      this.trainerProfile.photo = []
    }
      this.trainerProfile.org_id = this.$store.state.dataFilters.orgId
      this.trainerProfile.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.trainerProfile.office_id = this.$store.state.dataFilters.officeId
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      test: 0,
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      perShowData: 0,
      showData: 0,
      trainerProfile: {
        manpower_type: 0,
        fiscal_year_id: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        name: '',
        name_bn: '',
        gender: 0,
        nid: '',
        is_same: '',
        father_name: '',
        father_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        religion_id: 0,
        blood_group_id: 0,
        photo: [],
        org_name: '',
        org_name_bn: '',
        designation: '',
        designation_bn: '',
        service_id: '',
        pay_grade_en: '',
        pay_grade_bn: '',
        email: '',
        mobile_no: '',
        highest_degree_en: '',
        highest_degree_bn: '',
        board_university_en: '',
        board_university_bn: '',
        per_area_id: 0,
        per_division_id: 0,
        per_district_id: 0,
        per_upazila_id: 0,
        per_city_corporation_id: 0,
        per_paurasabha_id: 0,
        per_union_id: 0,
        per_ward_id: 0,
        pre_area_id: 0,
        pre_division_id: 0,
        pre_district_id: 0,
        pre_upazila_id: 0,
        pre_city_corporation_id: 0,
        pre_paurasabha_id: 0,
        pre_union_id: 0,
        pre_ward_id: 0,
        per_address_bn: '',
        per_address: '',
        pre_address: '',
        pre_address_bn: ''
      },
      upload_image: '',
      districtList: [],
      upazilaList: [],
      unionList: [],
      districtPerList: [],
      upazilaPerList: [],
      unionPerList: [],
      officeTypeList: [],
      officeList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      wardList: [],
      initFormData: {},
      areaTypeList: [
        { value: 1, text: this.$t('educational_management.city_corporation') },
        { value: 2, text: this.$t('educational_management.pourosoba') },
        { value: 3, text: this.$t('educational_management.name_of_union') }
      ],
      bloodGroupList: [
        { value: 1, text: this.$t('educational_management.a_pos') },
        { value: 2, text: this.$t('educational_management.a_neg') },
        { value: 3, text: this.$t('educational_management.b_pos') },
        { value: 4, text: this.$t('educational_management.b_neg') },
        { value: 5, text: this.$t('educational_management.o_pos') },
        { value: 6, text: this.$t('educational_management.o_neg') },
        { value: 7, text: this.$t('educational_management.ab_pos') },
        { value: 8, text: this.$t('educational_management.ab_neg') }
      ],
      religionList: [
        { value: 1, text: this.$t('educational_management.islam') },
        { value: 2, text: this.$t('educational_management.hindu') },
        { value: 3, text: this.$t('educational_management.christian') },
        { value: 4, text: this.$t('educational_management.buddhist') }
      ],
      genderList: [
        { value: 1, text: this.$t('educational_management.male') },
        { value: 2, text: this.$t('educational_management.female') }
      ]
    }
  },
  computed: {
    getManpowerTypeList: function () {
        return this.$store.state.ChildService.commonObj.manpowerTypeList.map(item => {
            return Object.assign({}, item, { value: item.value, text: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    divisionPreList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    divisionPerList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    }
  },
  watch: {
    'trainerProfile.org_id': function (newVal, oldVal) {
       this.officeTypeList = this.getOfficeTypeList(newVal)
    },
    'trainerProfile.office_type_id': function (newVal, oldVal) {
       this.officeList = this.getOfficeList(newVal)
    },
    'trainerProfile.pre_division_id': function (newVal, oldVal) {
      this.districtList = this.getPreDistrictList(newVal)
    },
    'trainerProfile.pre_district_id': function (newVal, oldVal) {
      this.upazilaList = this.getPreUpazilaList(newVal)
      this.cityCorporationList = this.getPreCityCorporationList(newVal)
    },
    'trainerProfile.pre_city_corporation_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByCityCorportaion(newVal)
    },
    'trainerProfile.pre_upazila_id': function (newVal, oldVal) {
      this.unionList = this.getPreUnionList(newVal)
      this.pauroshobaList = this.getPauroshobaList(newVal)
    },
    'trainerProfile.per_division_id': function (newVal, oldVal) {
      this.districtPerList = this.getPerDistrictList(newVal)
    },
    'trainerProfile.per_district_id': function (newVal, oldVal) {
      this.upazilaPerList = this.getPerUpazilaList(newVal)
      this.cityCorporationList = this.getPreCityCorporationList(newVal)
    },
    'trainerProfile.per_city_corporation_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByCityCorportaion(newVal)
    },
    'trainerProfile.per_upazila_id': function (newVal, oldVal) {
      this.unionPerList = this.getPerUnionList(newVal)
      this.pauroshobaList = this.getPauroshobaList(newVal)
    },
    'trainerProfile.pre_paurasabha_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByPauroshoba(newVal)
    },
    'trainerProfile.pre_area_id': function (newVal, oldVal) {
       this.getlocation(newVal)
    },
    'trainerProfile.per_area_id': function (newVal, oldVal) {
       this.getPerlocation(newVal)
    }
  },
  methods: {
    getlocation (areaID) {
        if (areaID === 1) {
            this.showData = 1
        }
        if (areaID === 2) {
            this.showData = 2
        }
        if (areaID === 3) {
            this.showData = 3
        }
        return true
    },
    getPerlocation (areaID) {
        if (areaID === 1) {
            this.perShowData = 1
        }
        if (areaID === 2) {
            this.perShowData = 2
        }
        if (areaID === 3) {
            this.perShowData = 3
        }
        return true
    },
    getOfficeTypeList (orgId) {
        return this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === orgId && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value))
    },
    getOfficeList (typeId) {
        return this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === typeId)
    },
    onImageChange (e) {
      this.upload_image = e.target.files[0]
    },
    gettrainerProfileData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
     isSameAsPresent (val) {
        if (parseInt(val) === 1) {
        this.trainerProfile.per_area_id = this.trainerProfile.pre_area_id
        this.trainerProfile.per_division_id = this.trainerProfile.pre_division_id
        this.trainerProfile.per_district_id = this.trainerProfile.pre_district_id
        this.trainerProfile.per_upazila_id = this.trainerProfile.pre_upazila_id
        this.trainerProfile.per_city_corporation_id = this.trainerProfile.pre_city_corporation_id
        this.trainerProfile.per_paurasabha_id = this.trainerProfile.pre_paurasabha_id
        this.trainerProfile.per_union_id = this.trainerProfile.pre_union_id
        this.trainerProfile.per_ward_id = this.trainerProfile.pre_ward_id
        this.trainerProfile.per_address_bn = this.trainerProfile.pre_address_bn
        this.trainerProfile.per_address = this.trainerProfile.pre_address
        } else {
        this.trainerProfile.per_area_id = 0
        this.trainerProfile.per_division_id = 0
        this.trainerProfile.per_district_id = 0
        this.trainerProfile.per_upazila_id = 0
        this.trainerProfile.per_city_corporation_id = 0
        this.trainerProfile.per_paurasabha_id = 0
        this.trainerProfile.per_union_id = 0
        this.trainerProfile.per_ward_id = 0
        this.trainerProfile.per_address_bn = ''
        this.trainerProfile.per_address = ''
        }
    },
    async registerInstructor () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: true }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      var formData = new FormData()
      Object.keys(this.trainerProfile).map(key => {
        if (key === 'photo') {
          formData.append(key, this.upload_image)
        } else {
          formData.append(key, this.trainerProfile[key])
        }
      })

      if (this.id) {
        formData.append('_method', 'POST')
        result = await RestApi.postData(childServiceBaseUrl, `${trainerProfileUpdateApi}/${this.id}`, formData, config)
      } else {
        result = await RestApi.postData(childServiceBaseUrl, trainerProfileStoreApi, formData, config)
      }
      this.$store.dispatch('mutateCommonProperties', loadinState)

      if (result.success) {
        this.$store.commit('ChildService/mutateCommonObj', { hasDropdownLoaded: false })
        this.$toast.success({
          title: 'Success',
          message: this.id ? 'Data updated successfully' : 'Data save successfully',
          color: '#D6E09B'
        })

        this.$bvModal.hide('modal-4')
      } else {
        this.$refs.form.setErrors(result.errors)
        this.$toast.error({
          title: 'Error',
          message: 'Operation failed! Please, try again.'
        })
      }
    },
    getPreDistrictList (divisionId = null) {
      const districtList = this.$store.state.commonObj.districtList

      if (divisionId) {
        return districtList.filter(district => district.division_id === divisionId)
      }

      return districtList
    },
    getPreUpazilaList (districtId = null) {
      const upazilaList = this.$store.state.commonObj.upazilaList

      if (districtId) {
        return upazilaList.filter(upazila => upazila.district_id === districtId)
      }

      return upazilaList
    },
    getPreCityCorporationList (districtId = null) {
      const cityCorporationList = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
      if (districtId) {
        return cityCorporationList.filter(upazila => upazila.district_id === districtId)
      }

      return cityCorporationList
    },
    getPauroshobaList (upazillaId = null) {
      const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
      if (upazillaId) {
          return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
    },
    getWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getPreUnionList (upazilaId = null) {
      const unionList = this.$store.state.commonObj.unionList
      if (upazilaId) {
        return unionList.filter(union => union.upazilla_id === upazilaId)
      }

      return unionList
    },
    getPerDistrictList (divisionId = null) {
      const districtPerList = this.$store.state.commonObj.districtList

      if (divisionId) {
        return districtPerList.filter(district => district.division_id === divisionId)
      }

      return districtPerList
    },
    getPerUpazilaList (districtId = null) {
      const upazilaPerList = this.$store.state.commonObj.upazilaList

      if (districtId) {
        return upazilaPerList.filter(upazila => upazila.district_id === districtId)
      }

      return upazilaPerList
    },
    getPerUnionList (upazilaId = null) {
      const unionPerList = this.$store.state.commonObj.unionList
      if (upazilaId) {
        return unionPerList.filter(union => union.upazilla_id === upazilaId)
      }

      return unionPerList
    },
    getWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    }
  }
}
</script>
